import { PhaseTypeEnum } from '@vatos-pas/common';

export type WorkflowOptionFlag = 'hasTrim' | 'hasExteriorPaint';

export type WorkflowOptionFlags = Partial<
  Record<WorkflowOptionFlag, boolean | null>
>;

export const PHASE_WORKFLOW_OPTION: Partial<
  Record<PhaseTypeEnum, WorkflowOptionFlag>
> = {
  [PhaseTypeEnum.Trim1]: 'hasTrim',
  [PhaseTypeEnum.Trim2]: 'hasTrim',
  [PhaseTypeEnum.ExteriorOne]: 'hasExteriorPaint',
  [PhaseTypeEnum.ExteriorTwo]: 'hasExteriorPaint',
};

export const isPhaseIncluded = (
  phaseType: PhaseTypeEnum,
  flags: WorkflowOptionFlags | null | undefined,
): boolean => {
  const flag = PHASE_WORKFLOW_OPTION[phaseType];
  return !flag || !!flags?.[flag];
};

export const isExteriorPaintPhase = (phaseType: PhaseTypeEnum): boolean =>
  PHASE_WORKFLOW_OPTION[phaseType] === 'hasExteriorPaint';
